import { objectWithoutProperties as _objectWithoutProperties, defineProperty as _defineProperty, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React from 'react';
import { getClassName } from '../../utils/index.js';
var _excluded = ["type", "theme", "size", "block", "disabled", "loading", "desc", "className", "children", "onClick"];
var Button =
/*#__PURE__*/
React.forwardRef(function (_ref, ref) {
  var _classNames;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'white' : _ref$theme,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$block = _ref.block,
      block = _ref$block === void 0 ? false : _ref$block,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      desc = _ref.desc,
      className = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var classes = classNames(getClassName('btn'), getClassName('btn', theme), getClassName('btn', size), (_classNames = {}, _defineProperty(_classNames, getClassName('btn', 'block'), block), _defineProperty(_classNames, getClassName('btn', 'disabled'), disabled), _defineProperty(_classNames, getClassName('btn', 'loading'), loading), _defineProperty(_classNames, getClassName('btn', 'with-desc'), !!desc), _defineProperty(_classNames, getClassName('btn', 'link'), restProps.href !== undefined), _classNames), className);

  var handleClick = function handleClick(event) {
    if (disabled || loading) {
      event.preventDefault();
      return;
    }

    onClick === null || onClick === void 0 ? void 0 : onClick(event);
  };

  var isLink = restProps.href !== undefined;
  if (isLink) return (
    /*#__PURE__*/
    React.createElement("a", _objectSpread2({
      ref: ref,
      className: classes,
      onClick: handleClick
    }, restProps), children, desc &&
    /*#__PURE__*/
    React.createElement("span", {
      className: getClassName('btn', 'desc')
    }, desc))
  );
  return (
    /*#__PURE__*/
    React.createElement("button", _objectSpread2({
      ref: ref,
      className: classes,
      onClick: handleClick,
      type: type
    }, restProps), children, desc &&
    /*#__PURE__*/
    React.createElement("span", {
      className: getClassName('btn', 'desc')
    }, desc))
  );
});
export { Button as default };